/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown>, amount: NonNullable<unknown> }} Equivalence_ElephantInputs */

const en_us2_equivalence_elephant = /** @type {(inputs: Equivalence_ElephantInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`the weight of an elephant`);
	return /** @type {LocalizedString} */ (`the weight of ${i?.amount} elephants`)
	
};

const pt_br2_equivalence_elephant = /** @type {(inputs: Equivalence_ElephantInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`o peso de um elefante`);
	return /** @type {LocalizedString} */ (`o peso de ${i?.amount} elefantes`)
	
};

const es_419_equivalence_elephant = /** @type {(inputs: Equivalence_ElephantInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`el peso de un elefante`);
	return /** @type {LocalizedString} */ (`el peso de ${i?.amount} elefantes`)
	
};

const pt_pt2_equivalence_elephant = /** @type {(inputs: Equivalence_ElephantInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`o peso de um elefante`);
	return /** @type {LocalizedString} */ (`o peso de ${i?.amount} elefantes`)
	
};

const fr_fr2_equivalence_elephant = /** @type {(inputs: Equivalence_ElephantInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`le poids d'un éléphant`);
	return /** @type {LocalizedString} */ (`le poids de ${i?.amount} éléphants`)
	
};

const de_de2_equivalence_elephant = /** @type {(inputs: Equivalence_ElephantInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`das Gewicht eines Elefanten`);
	return /** @type {LocalizedString} */ (`das Gewicht von ${i?.amount} Elefanten`)
	
};

const it_it2_equivalence_elephant = /** @type {(inputs: Equivalence_ElephantInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`il peso di un elefante`);
	return /** @type {LocalizedString} */ (`il peso di ${i?.amount} elefanti`)
	
};

/**
* | count | output |
* | --- | --- |
* | "1" | "the weight of an elephant" |
* | * | "the weight of {amount} elephants" |
*
* @param {Equivalence_ElephantInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const equivalence_elephant = /** @type {((inputs: Equivalence_ElephantInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Equivalence_ElephantInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_equivalence_elephant(inputs)
	if (locale === "es-419") return es_419_equivalence_elephant(inputs)
	if (locale === "pt-PT") return pt_pt2_equivalence_elephant(inputs)
	if (locale === "fr-FR") return fr_fr2_equivalence_elephant(inputs)
	if (locale === "de-DE") return de_de2_equivalence_elephant(inputs)
	if (locale === "it-IT") return it_it2_equivalence_elephant(inputs)
	return en_us2_equivalence_elephant(inputs)
});
export { equivalence_elephant as "equivalence.elephant" }